<ng-container *ngIf="jobStatistics$ | async as jobStatistics">
    <section class="card">
        <header>
            <ng-content select="[formHeading]"></ng-content>
        </header>
        <div class="card-content">
            <app-statistics-details [jobStatistics]="jobStatistics"></app-statistics-details>
        </div>
    </section>
</ng-container>
